<template>
  <div>
    <base-button variant="link" :show-loader="isLoading" :icon-prepend="['fal', 'download']" @click="onClick">
      <span :title="filename">{{truncatedName}}</span>
    </base-button>
    <base-button class="ml-2" v-if="canRemove && isOnRemoveActive" variant="link-danger" @click="onRemove"><font-awesome-icon :icon="['fal', 'trash-alt']" /></base-button>
  </div>
</template>

<script>
export default {
  name: 'BaseAttachment',

  data () {
    return {
      isLoading: false,

      isOnClickActive: Boolean(this.$listeners['click']),
      isOnRemoveActive: Boolean(this.$listeners['remove'])
    }
  },

  props: {
    reference: {
      required: true,
      type: String
    },
    filename: {
      type: String,
      required: true
    },
    mimeType: {
      type: String
    },
    canRemove: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    truncatedName () {
      return this.filename.replace(new RegExp('(^[^\\.]{20})[^\\.]+'), '$1...')
    }
  },

  methods: {
    onClick () {
      if (this.isOnClickActive) {
        this.isLoading = true

        this.$listeners.click(this.reference).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: response.data.type }))
          const link = document.createElement('a')
          link.href = url
          link.target = '_blank'
          const contentDisposition = response.headers['content-disposition']
          let fileName = 'unknown'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (fileNameMatch.length > 1) {
              fileName = fileNameMatch[1]
            }
          }
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)

          this.isLoading = false
        })
      }
    },

    onRemove () {
      this.$store.dispatch('showModal', {
        component: {
          is: 'MessageModal',
          data: {
            message: this.$i18n.t('sentence.{label}DeleteConfirmation', { label: `${this.$i18n.t('label.attachment')} - ${this.filename}` })
          }
        },
        options: {
          title: this.$i18n.t('label.delete{label}', { label: this.$i18n.t('label.attachment') }),
          size: 'md'
        },
        events: {
          ok: () => this.removeAttachment()
        },
        actions: [{
          onClick: ({ cancel }) => cancel(),
          options: {
            title: this.$i18n.t('label.cancel'),
            variant: 'link',
            class: 'mr-3 btn-link--primary'
          }
        }, {
          onClick: ({ ok }) => ok(),
          options: {
            title: this.$i18n.t('label.delete'),
            variant: 'danger',
            isPill: true
          }
        }]
      })
    },

    /**
     * Remove attachment
     */
    removeAttachment () {
      this.isLoading = true

      this.$listeners.remove(this.reference).then(() => {
        this.isLoading = false
      })
    }
  }
}
</script>
